<style scoped>
.modal-footer {
    display: block;
    text-align: center;
}
</style>
<template>
    <div class="modal-content" ref="container">
        <div class="modal-header">
            <h2 class="modal-title">Confirm Submission</h2>
            <button type="button" class="close icon icon-close" aria-hidden="true" @click="$emit('close')" autofocus :disabled="submitting" aria-label="Close" />
        </div>
        <div class="modal-body">
            <template v-if="!submitting">
                <p describedby-text>Are you sure you want to submit?</p>
                <template v-if="confirmComponents.length > 0">
                    <template v-for="confirmComponent in confirmComponents">
                        <component :is="confirmComponent.component" :data="confirmComponent.data"></component>
                    </template>
                </template>
            </template>
            <div v-if="submitting">
                <LoadingWheel :width="100" />
            </div>
        </div>
        <div class="modal-footer">
            <button v-for="submitButton in submitButtons" class="btn btn-primary my-2" @click="submit(submitButton.trigger)" :disabled="submitting || blockSubmit">{{ truncateLongText(submitButton.text) }}</button>
            <button class="btn btn-outline-secondary my-2" @click="$emit('close')" :disabled="submitting">Cancel</button>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, SetupContext } from "vue";
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
import type { Observable } from "rxjs";
import { useObservable } from "@vueuse/rxjs";
import { dialogSetup } from "@/lib/dialogMixin.3";
interface Props {
    submitFunction: (triggerKey: string | null) => Promise<() => Promise<void>>;
    /* eslint-disable @typescript-eslint/no-explicit-any*/ // TODO
    confirmComponents: { component: any; data: any }[];
    submitButtons: any[];
    blockSubmit$: Observable<any>;
}
export default defineComponent({
    props: ["submitFunction", "confirmComponents", "submitButtons", "blockSubmit$"],
    components: {
        LoadingWheel,
    },
    setup(props: Props, { emit }: SetupContext) {
        const containerRef = ref<HTMLElement>(null!);
        dialogSetup(containerRef);
        const submitting = ref(false);

        const submit = async (triggerKey: string | null) => {
            submitting.value = true;
            const post = await props.submitFunction(triggerKey);
            await post();
            submitting.value = false;
            emit("close");
        };

        // TODO refactor into utils
        const truncateLongText = (text: string) => {
            if (text == null || text.length <= 40) {
                return text;
            } else {
                return text.slice(0, 40) + "...";
            }
        };

        return {
            container: containerRef,
            submitting,
            blockSubmit: useObservable(props.blockSubmit$),
            submit,
            truncateLongText,
        };
    },
});
</script>
